<template>
  <div class="microsoft-callback">
    <div class="callback-card">
      <h5 class="mb-2">Microsoft Sign-In</h5>
      <p class="mb-0">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "Completing Microsoft sign-in...",
    };
  },

  mounted() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error_description") || params.get("error");

    if (window.opener) {
      window.opener.postMessage(
        {
          type: "microsoft-auth-code",
          code,
          state,
          error,
        },
        window.location.origin
      );
    }

    if (error) {
      this.message = error;
    } else {
      this.message = "Microsoft sign-in completed. You can close this window.";
    }

    setTimeout(() => {
      window.close();
    }, 1200);
  },
};
</script>

<style scoped>
.microsoft-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f7fb;
}

.callback-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  padding: 24px 28px;
  width: 100%;
  max-width: 420px;
}
</style>
